import {
  INICIALITZAR,
  INDRET_INICIALITZAR,
  OBTENIR_DADES_INDRET,
  INDRET_INTRODUCCIO_DESCARTAR_CANVIS,
  INDRET_INTRODUCCIO_FOTOS_CREAR_FOTO,
  INDRET_INTRODUCCIO_FOTOS_ELIMINAR_FOTO,
  INDRET_INTRODUCCIO_FOTOS_DESCARTAR_FOTO
} from "../../../actions/actionTypes";

export const ESTAT_INICIAL = {
  originals: [],
  eliminades: [],
  creades: []
};

const fotos = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INDRET_INICIALITZAR:
    case INICIALITZAR:
    case `${OBTENIR_DADES_INDRET}_EN_CURS`:
    case `${OBTENIR_DADES_INDRET}_ERROR`:
      return ESTAT_INICIAL;

    case `${OBTENIR_DADES_INDRET}_SUCCESS`: {
      return {
        originals: action.payload.fotos,
        eliminades: [],
        creades: []
      };
    }

    case INDRET_INTRODUCCIO_DESCARTAR_CANVIS:
      return {
        originals: state.originals,
        eliminades: [],
        creades: []
      };

    case INDRET_INTRODUCCIO_FOTOS_ELIMINAR_FOTO:
      return {
        ...state,
        eliminades: [...state.eliminades, action.foto]
      };

    case INDRET_INTRODUCCIO_FOTOS_DESCARTAR_FOTO:
      return {
        ...state,
        creades: [
          ...state.creades.slice(0, action.indexFoto),
          ...state.creades.slice(action.indexFoto + 1)
        ]
      };

    case INDRET_INTRODUCCIO_FOTOS_CREAR_FOTO:
      return {
        ...state,
        creades: [...state.creades, action.foto]
      };

    default:
      return state;
  }
};

export default fotos;
